(() => {
  'use strict';
  const source = document.getElementById('FultonsProductSearchData');
  const main = document.getElementById('MainContent');
  if (!source || !main) return;
  let product;
  try { product = JSON.parse(source.textContent); } catch { return; }
  const baseJson = JSON.stringify(product).replace(/</g, '\\u003c');
  const visible = element => element.getClientRects().length > 0 &&
    getComputedStyle(element).visibility !== 'hidden' && !element.closest('[hidden]');
  const exactPrice = text => {
    const match = text.trim().match(/^(?:Fultons price\s*)?£([\d,]+(?:\.\d{1,2})?)$/);
    const amount = match ? Number(match[1].replace(/,/g, '')) : NaN;
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  };
  let queued = false;
  function update() {
    queued = false;
    // Read the customer's selected selling price. Never use Shopify placeholder
    // variants, RRPs, 'from' prices, hidden configuration rows or stock guesses.
    const candidates = Array.from(main.querySelectorAll(
      '.fsp-amount, .fultons-selected-price__sale, .fsd-result > strong, .fap-sale'
    )).filter(visible);
    if (!candidates.length && main.querySelector('.fultons-wood-options')) {
      candidates.push(...Array.from(main.querySelectorAll('.fultons-retail-price > span')).filter(visible));
    }
    const prices = [...new Set(candidates.map(e => exactPrice(e.textContent)).filter(n => n !== null))];
    const output = source;
    if (prices.length !== 1) {
      if (output.textContent !== baseJson) output.textContent = baseJson;
      return;
    }
    const galleryImage = main.querySelector('.fultons-gallery__open img');
    const result = {
      ...product,
      ...(galleryImage ? { image: galleryImage.src } : {}),
      offers: {
        '@type': 'Offer', priceCurrency: 'GBP', price: prices[0], url: product.url,
        seller: { '@type': 'Organization', name: 'Fultons', url: 'https://fultons.com/' }
      }
    };
    const json = JSON.stringify(result).replace(/</g, '\\u003c');
    if (output.textContent !== json) output.textContent = json;
  }
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  };
  // Observe only product content; writing the head cannot feed back into this observer.
  new MutationObserver(schedule).observe(main, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ['hidden', 'src']
  });
  document.addEventListener('fultons:catalogue-updated', schedule);
  main.addEventListener('change', schedule);
  schedule();
})();
